import { render, staticRenderFns } from "./Saidas.vue?vue&type=template&id=42377760&scoped=true"
import script from "./Saidas.vue?vue&type=script&lang=js"
export * from "./Saidas.vue?vue&type=script&lang=js"
import style0 from "./Saidas.vue?vue&type=style&index=0&id=42377760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42377760",
  null
  
)

export default component.exports